export const GOOGLE_RECAPTCHA_LINKS = {
  GOOGLE_PRIVACY_POLICY: 'https://policies.google.com/privacy',
  GOOGLE_TERM_OF_SERVICE: 'https://policies.google.com/terms',
};

export const MAIN_WEBSITE_LINKS = {
  HOME: 'https://www.leal.health',
  PRIVACY_POLICY: 'https://www.leal.health/privacy-policy',
  TERMS: 'https://www.leal.health/terms',
  ONCOLOGISTS: 'https://leal.health/oncologists',
  OTHER_DISEASE: 'https://leal.health/other-cancer-types',
};
